import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-37f381f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "multi-frame" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_flvPlayer = _resolveComponent("flvPlayer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(`layout layout-${_ctx.frameNum}`)
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.showUrls, (url) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "frame-com",
          key: url
        }, [
          _createVNode(_component_flvPlayer, { url: url }, null, 8, ["url"])
        ]))
      }), 128)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.frameNum-_ctx.showUrls.length), (item) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "frame-com",
          key: item
        }))
      }), 128))
    ], 2)
  ]))
}